import React from 'react';
import { CTAButton } from './ui/CTAButton';
import { LockIcon, TruckIcon, ShieldCheckIcon } from 'lucide-react';
export function FinalCTASection() {
  return <section className="w-full bg-blue-600 text-white py-16 px-4" data-id="element-60">
      <div className="max-w-4xl mx-auto text-center" data-id="element-61">
        <h2 className="text-3xl md:text-5xl font-extrabold mb-6" data-id="element-62">
          No Dejes Que el Dolor Te Detenga
        </h2>
        <p className="text-xl md:text-2xl text-blue-100 mb-8" data-id="element-63">
          Vuelve a moverte con libertad por solo{' '}
          <span className="font-bold text-white" data-id="element-64">$699 MXN</span>
        </p>

        <div className="max-w-md mx-auto mb-8" data-id="element-65">
          <CTAButton className="bg-green-500 hover:bg-green-400 text-slate-900 shadow-xl" data-id="element-66" />
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-6 text-blue-100 font-medium" data-id="element-67">
          <div className="flex items-center gap-2" data-id="element-68">
            <TruckIcon className="w-6 h-6" data-id="element-69" />
            <span data-id="element-70">Envío Gratis</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-71">
            <LockIcon className="w-6 h-6" data-id="element-72" />
            <span data-id="element-73">Compra Segura</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-74">
            <ShieldCheckIcon className="w-6 h-6" data-id="element-75" />
            <span data-id="element-76">Pago Contra Entrega</span>
          </div>
        </div>
      </div>
    </section>;
}